(function(){
  function repair(){
    const header=document.getElementById('header-group');
    if(!header)return;
    header.querySelectorAll('a[href="/pages/affiliate-program"]').forEach(function(link){
      link.setAttribute('href','/pages/partner-with-us');
    });
    header.querySelectorAll('a[href*="/search?"]').forEach(function(link){
      try {
        var destination=new URL(link.href,window.location.origin);
        if (destination.pathname==='/search' && destination.searchParams.get('q')?.trim().toLowerCase()==='queen life') {
          link.setAttribute('href','/collections/queen-life-trending');
        }
      } catch (err) {}
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',repair,{once:true});
  else repair();
  const group=document.getElementById('header-group');
  if(group){
    repair();
    const observer=new MutationObserver(repair);
    observer.observe(group,{childList:true,subtree:true,attributes:true,attributeFilter:['href']});
  }
})();